export const PLUS_TEST_KEYS = [
  "pricing_experiment",
  "shipping_experiment",
] as const;

export const CORE_CONTENT_TEST_KEYS = [
  "volume_discount_experiment",
  "onsite_test",
  "template_test",
  "theme_test",
  "checkout_block_experiment",
  "advanced_test",
] as const;
